<template>
  <div>
    <span class="material-input-bar" />
    <label class="material-label">
      <slot />
    </label>
    <el-switch
      v-model="currentValue"
      style="display: inline-block"
      :name="name"
      :readonly="readonly"
      :required="required"
      :disabled="disabled"
      :active-color="activeColor"
      :inactive-color="inactiveColor"
      :active-text="$t(activeText)"
      :inactive-text="$t(inactiveText)"
      @input="handleModelInput"
    >
    </el-switch>
  </div>
</template>
<script>
export default {
  props: {
    name: String,
    value: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    activeColor: {
      type: String,
      default: '#6bb80a'
    },
    inactiveColor: {
      type: String,
      default: '#c7c7c7'
    },
    activeText: {
      type: String,
      default: 'common.switchOn'
    },
    inactiveText: {
      type: String,
      default: 'common.switchOff'
    }
  },
  data() {
    return {
      currentValue: this.value
    };
  },
  watch: {
    value(newValue) {
      this.currentValue = newValue;
    }
  },
  methods: {
    handleModelInput(value) {
      this.$emit('input', value);
      this.$emit('change', value);
    }
  }
};
</script>
